import {injectable} from "tsyringe";
import {DeleteKeywordCommand} from "../commands/delete-keyword.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {Keyword} from "../domain/entities/keyword.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({source: DeleteKeywordCommand, target: `dto`})
export class DeleteKeywordCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Keyword> {

    protected async toDTO(keyword: Keyword): Promise<DataTransferObject> {
        return Promise.resolve(<DataTransferObject>{uid: keyword.uid});
    }

}
